import qs from "qs";

export const TV_FULL_SCREEN_QUERY_PARAM = "tv_full_screen";
export const TV_FULL_SCREEN_QUERY_VALUE = "true";

export const FE_STOCK_PAGE_URL_PATTERN = "fe.stockPage";
export const FE_STOCK_PAGE_WITH_TV_FULL_SCREEN_URL_PATTERN =
  "fe.stockPageWithTvFullScreen";

export function hasTvFullScreenQuery(search) {
  const params = qs.parse(search || "", { ignoreQueryPrefix: true });
  return params[TV_FULL_SCREEN_QUERY_PARAM] === TV_FULL_SCREEN_QUERY_VALUE;
}

export function withTvFullScreenSearch(search, enabled) {
  const params = qs.parse(search || "", { ignoreQueryPrefix: true });

  if (enabled) {
    params[TV_FULL_SCREEN_QUERY_PARAM] = TV_FULL_SCREEN_QUERY_VALUE;
  } else {
    delete params[TV_FULL_SCREEN_QUERY_PARAM];
  }

  const serialized = qs.stringify(params);
  return serialized ? `?${serialized}` : "";
}

export function getStocksListResultUrlPattern(isFullscreenView) {
  return isFullscreenView
    ? FE_STOCK_PAGE_WITH_TV_FULL_SCREEN_URL_PATTERN
    : FE_STOCK_PAGE_URL_PATTERN;
}
